import $ from 'jquery';
import * as d3 from 'd3';

import './furniture';

import demographics from './demographics';
import chart from './fin-health-chart';
import retrieve from './retrieve-data';
import treemap from './treemap';
import revexp from './revenue-expense';
import fever from './fever';

let data;
let selectedPriceYear;
let livingArr;
let residency;

let selectedNetPrice;

let searchBoxData;

const addCommas = d3.format(',');
// Find page URL
const pageUrl = window.location;
// find wilberforce, other schools

let pageUnitid;

if (pageUrl.href.includes("wilberforce")) {
  pageUnitid = '206491'
} else if (pageUrl.href.includes("akron")) {
  pageUnitid = '200800'
} else if (pageUrl.href.includes("grande")) {
  pageUnitid = '205203'
} else {
  pageUnitid = pageUrl.href.split('=')[1];
}
function numberWithCommas(n) {
    var parts=n.toString().split(".");
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
}
if (pageUnitid) {

  $.getJSON(`./data/school-data/${pageUnitid}.json`, (data) => {
      // SIDEBAR SCHOOL INFO
      var site = "http://" + data.website;
      $('#stats-url a, #mobile-stats-url a').attr("href", site);

      if (data.level === 1 || data.level === 4){
        $('#school-stats-type').html("public");
      } else if (data.level === 2){
          $('#school-stats-type').html("private");
        } else {
          $('#school-stats-type').html("");
        }
      if (data.level === 1 || data.level === 4){
        $('.stats-type').html("public");
      } else if (data.level === 2){
          $('.stats-type').html("private");
        } else {
          $('.stats-type').html("for-profit");
        }
      if (data.level === 1) {
        $(".campus-size-icon").attr("src","./images/_college.png");
        $('#budget-fluff span').html("public four-year institutions");
      } else if (data.level < 3 && data.graduation_rate > 0.95) {
        $(".campus-size-icon").attr("src","./images/_harvard.png");
      } else if (data.level < 3) {
        $(".campus-size-icon").attr("src","./images/_college2.png");
      } else {
        $('.campus-size-icon').attr('src','./images/_students.png')
      }
      if (data.level < 4){
          $('#school-stats-degree').html("four-year university");
        } else {
          $('#school-stats-degree').html("two-year college");
        }
      if (data.level < 4){
          $('#copy-span-degree').html("four-year");
        } else {
          $('#copy-span-degree').html("two-year");
        }
       if (data.level === 2) {
        $('#budget-fluff span').html("private four-year colleges");
       } else if (data.level === 4) {
        $('#budget-fluff span').html("public two-year colleges");
       }


      // FLAGGING

      // if (data.level == 1) {
      //   const sysName = data.institution.split('-')
      //   $(".school-link a").html("See other institutions within the " + sysName[0] + " system")
      // }

      var targets; 
      var idTargets;

      if (data.level == 1) {
        targets = ["enrollment", "retention", "tuition", "appropriations"]
        idTargets = ["first", "second", "third", "fourth"]
      } else if (data.level == 2) {
        targets = ["enrollment", "retention", "tuition", "appropriations"]
        idTargets = ["first", "second", "third", "fourth"]
      } else {
        targets = ["enrollment", "tuition", "appropriations"]
        idTargets = ["first", "third", "fourth"]
      }
      const theFlags = data.flags

      const flagggs = theFlags.replace('[', '').replace(']', '')

      var theFlagsData = flagggs.split(',').map(function(item) {
          return parseInt(item, 10);
      });
      
      if (data.level == 4) {
        $('.score-bar-retention').addClass("disabled")
        $('.metrics-section-second').addClass("disabled")
        $('.score-bar-tuition > .score-bar-title').html("Tuition/costs")
      }

      if (data.level == 2) {
        $('.score-bar-appropriations').addClass("condensed");
        $('.score-bar-appropriations > .score-bar-title').html("Endowment/costs");
      }

      for (var i in theFlagsData) {
        if (isNaN(theFlagsData[i])) {
          $('.score-bar-' + targets[i]).addClass("faded")
          $('.metrics-section-' + idTargets[i]).addClass("disabled")

          $('.score-bar-' + targets[i] + ' > .score-bar-na').removeClass("invisible")
        } 
        for (var j = 1; j <= theFlagsData[i]; j++) {
          $('#score-bar-score-' + targets[i] + '> .score-bar-' + j).addClass("flagged")
        }
      }
      const flagCheck = theFlagsData.filter(function (value) {
        return !Number.isNaN(value);
      });

      const flagSum = flagCheck.reduce(function(a, b){
            return a + b;
        }, 0);

      // tktktktktk
      if (flagSum > 3) {
        $('#red-flags-text-sum').html("with several warning signs")
      } else if (isNaN(theFlagsData[0]) && isNaN(theFlagsData[1]) && isNaN(theFlagsData[2]) && isNaN(theFlagsData[3])) {
        $('#red-flags-text-sum').html("without enough data to test for warning signs")
      } else if (flagSum<1) {
        $('#red-flags-text-sum').html("without warning signs")
      }  else {
        $('#red-flags-text-sum').html("with a warning sign")
      }

      let flagWarningText = '';
      let flagAlertText = '';

      var flagWarningLabels = [];
      var flagAlertLabels = [];
      var flagLabels;

      if (data.level == 1) { 
        flagLabels = ["enrollment", "retention", "average tuition and fees", "appropriations"]
      } else if (data.level == 2) {
        flagLabels = ["enrollment", "retention", "average tuition and fees", "endowment to expenses"]
      } else {
        flagLabels = ["enrollment", "tuition to expenses", "appropriations"]
      }

      for (let i in theFlagsData) {
        if (theFlagsData[i] == 2 || theFlagsData[i] == 1) {
          flagWarningLabels.push(flagLabels[i])
        } else if (theFlagsData[i] == 3) {
          flagAlertLabels.push(flagLabels[i])
        }
      }


      if (flagWarningLabels.length == 1) {
        flagWarningText = "The institution's score for " + flagWarningLabels[0] + " is projected to reach or fall below the warning level. "
      } else if (flagWarningLabels.length > 1) {
          const frag = " and " + flagWarningLabels.pop(); 
          flagWarningText = "The institution's scores for " + flagWarningLabels.join(", ") + frag + " are projected to reach or fall below the warning level.";
      }

      if (flagAlertLabels.length == 1) {
        flagAlertText = "The institution's score for " + flagAlertLabels[0] + " is projected to fall below the alert level. "
      } else if (flagAlertLabels.length > 1) {
          const frag = " and " + flagAlertLabels.pop(); 
          flagAlertText = "The institution's scores for " + flagAlertLabels.join(", ") + frag + " are projected to fall below the alert level.";
      }

      $('#red-flags-text-warning').html(flagWarningText)
      $('#red-flags-text-alert').html(flagAlertText)

      if (data.enrollment>0) {
        $('#school-stats-enrollment').html('Fall enrollment: ' + numberWithCommas(data.enrollment) + ' (2018-19)');
      } else {
        $('#school-stats-enrollment').html('Fall enrollment: N/A');
      }

      if (data.reporting_issue==1 ) {
        $('.error-bar').addClass('displayed')
        $('.error-bar').html('Due to a change in data reporting by ' + data.institution + ' during the analysis period, enrollment data is not included in this institution’s stress test.')
      }

      $('.city-state-label').html(data.city + ', ' + (data.abbreviation || ''));
      $('#copy-span-region').html(data.region);
      $('.school-name').html(data.institution);
      if (data.institution.length > 24) {
        $('.school-name').addClass("long-name")
      }
      if (data.institution.length > 35) {
        $('.school-name').addClass("extra-long-name")
      }


  // Build enrollment bar chart - race breakdown

    // $(".race-bar, .grad-bar").each(function() {
    //   const pct = $(this).attr("data-pct");
    //   $(this).css('width',pct+'%');
    // });

    // $(".bar-data").each(function() {
    //   const left = $(this).attr("data-left");
    //   $(this).css('left',left+'%');
    //   $(this).html(left+"%")
    // });

  // $('.embed-code').click(function(){
  //   $('.embed-code').addClass('markup')
  //   $('#embed-code').text(`<iframe style="overflow:hidden;height:375px;width:420px" height="375" width="420" scrolling="no" src="https://www.tuitiontracker.org/embed.html?unitid=${pageUnitid}"></iframe>`);
  // })












  // AUTOCOMPLETE

    const submitIcon = $('.searchbox-icon');
    const closeIcon = $('#results-close');
    const inputBox = $('.searchbox-input');
    const searchBox = $('.searchbox');
    let isOpen = false;
    closeIcon.click(function(){
        if(isOpen == true){
            searchBox.removeClass('searchbox-open');
            inputBox.focusout();
            isOpen = false;
            $('.searchbox-icon').css('display','inline-block');
            $('.new-searchbox-icon').hide();
        } else {
            searchBox.addClass('searchbox-open');
            inputBox.focus();
            isOpen = true;
            $('.new-searchbox-icon').show();
        }
    });
    submitIcon.click(function(){
        if(isOpen == false){
            searchBox.addClass('searchbox-open');
            inputBox.focus();
            isOpen = true;
            $(this).css('display','none');
            $('.new-searchbox-icon').show();
        } else {
            searchBox.removeClass('searchbox-open');
            inputBox.focusout();
            isOpen = false;
            $('.new-searchbox-icon').hide();
        }
    });

    const centralDatafile = retrieve.findData(data)

    // Run the charts code for each type of chart
    let demographicsDatafile = demographics.findData(data);
      demographics.runData(demographicsDatafile[4])
    
    let enrollment_count = 0;
    for (var i = 0; i < demographicsDatafile.length; i++) {
      if (demographicsDatafile[i]['all'] == 0) {
        $('.map-year-' + (2014 + i)).addClass("off")
        enrollment_count += 1;
      }
      if (enrollment_count == 5) {
        $('#map-error-message').addClass("off")
        $('#map').addClass("off")
        $('#map-international').addClass("off")
        $('.map-year').addClass("all-off")
      }
    }

    $('.map-year').on('click', function(e){
      $('.map-year').removeClass('selected')
      $(this).addClass('selected')
      const clicker = +$(this).text() - 2014;
      if (demographicsDatafile[clicker]['all'] > 0) {
        demographics.runData(demographicsDatafile[clicker])
      }
    })

    if (data.level === 1) {
      chart.runData(centralDatafile, 'enrollment', 'first', theFlagsData[0],data.level);
      chart.runData(centralDatafile, 'retention', 'second', theFlagsData[1],data.level);
      chart.runData(centralDatafile, 'tuition', 'third', theFlagsData[2],data.level);
      chart.runData(centralDatafile, 'appropriations', 'fourth', theFlagsData[3],data.level);
    } else if (data.level === 2) {
      
      chart.runData(centralDatafile, 'enrollment', 'first', theFlagsData[0],data.level);
      chart.runData(centralDatafile, 'retention', 'second', theFlagsData[1],data.level);
      chart.runData(centralDatafile, 'tuition', 'third', theFlagsData[2],data.level);
      chart.runData(centralDatafile, 'endowment', 'fourth', theFlagsData[3],data.level);
    } else if (data.level === 4) {
      chart.runData(centralDatafile, 'appropriations', 'fourth', theFlagsData[2],data.level);
      chart.runData(centralDatafile, 'enrollment', 'first', theFlagsData[0],data.level);
      chart.runData(centralDatafile, 'tuition_instruction', 'third', theFlagsData[1],data.level);
    }

    fever.runData(centralDatafile, "applications")
    fever.runData(centralDatafile, "perc_admitted")
    fever.runData(centralDatafile, "perc_yield")

    // treemap.runData(data)
    revexp.runData(data, "revenue", "revenue-chart", 4, data.level)
    revexp.runData(data, "expenses", "expenses-chart", 4,data.level)

    $('.budget-year').on('click', function(e){
      $('.budget-year').removeClass('selected')
      $(this).addClass('selected')
      const clicker = +$(this).text() - 2014;
      revexp.runData(data, "revenue", "revenue-chart", clicker,data.level)
      revexp.runData(data, "expenses", "expenses-chart", clicker,data.level)
    })


  }); // end getJSON
}

